<template>
  <div>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <h4 class="mb-0">
          Ativar Unidade
        </h4>
      </div>
      <b-table
        ref="refInstitutionListTable"
        class="position-relative"
        :items="fetchItems"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Nenhum registro correspondente encontrado"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(institution_name)="{ item }">
          <div :title="item.institution">
            <div>{{ truncateString(item.institution_name, 40) }}</div>
            <div class="font-small-2">
              {{ formatCnpj(item.institution_cnpj) }}
            </div>
          </div>
        </template>
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              @click="openModalActivate(data.item)"
            >
              <feather-icon icon="CheckCircleIcon" />
              <span class="align-middle ml-50">Ativar</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Exibindo {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalWorkplaces"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <workplace-activate-modal
      ref="workplaceActivateModal"
      @refetch-data="refetchData"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BTable, BPagination, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import store from '@/store'
import { onUnmounted, ref } from '@vue/composition-api'
import { formatCnpj, truncateString } from '@core/utils/utils'
import useWorkplacePendingActivationsList from './useWorkplacePendingActivationsList'
import reportStoreModule from '../../reportStoreModule'
import WorkplaceActivateModal from './workplace-activate/WorkplaceActivateModal.vue'

export default {
  components: {
    WorkplaceActivateModal,
    BDropdownItem,
    BDropdown,
    BCard,
    BRow,
    BCol,
    BTable,
    BPagination,
  },
  methods: { truncateString, formatCnpj },
  setup() {
    const STORE_MODULE_NAME = 'app-reports'

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, reportStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const workplaceActivateModal = ref(null)

    function openModalActivate(workplace) {
      workplaceActivateModal.value.show(workplace)
    }

    const {
      fetchItems,
      tableColumns,
      perPage,
      currentPage,
      totalWorkplaces,
      dataMeta,
      sortBy,
      isSortDirDesc,
      refInstitutionListTable,
      refetchData,
    } = useWorkplacePendingActivationsList()

    return {
      fetchItems,
      tableColumns,
      perPage,
      currentPage,
      totalWorkplaces,
      dataMeta,
      sortBy,
      isSortDirDesc,
      refInstitutionListTable,
      refetchData,
      workplaceActivateModal,
      openModalActivate,
    }
  },
}
</script>
